<ion-app>
  <fl-loading></fl-loading>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
